<template>
  <div class="contact_me" >
    <div class="list_wrap" v-if="dataList.length">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~"> 
        <div class="item" v-for="(item,index) in dataList" :key="index">
          <div class="item_top">
            <div class="logo">
              <img :src="item.matedata.From.AvatarUrl" v-if="item.matedata.From.AvatarUrl" v-load="'oAvatar'"/>
              <img src="@assets/img/empty.png"  v-else>
            </div>
            <div class="details">
              <div class="line">
                <span class="name">{{item.matedata.From.Name}}</span>
                <span class="job">{{item.matedata.From.JobTitle}}</span>
              </div>
              <div class="info2">{{item.matedata.From.CompName}}</div>
            </div>
            <div class="create_time">{{item.createAt}}</div>
          </div>
          <div class="item_bottom">
            <p>{{item.content}}</p>
            <div class="bottom-btn">
                <span class="lose" v-if="!item.toClickCount&&item.toState!=1" @click="loseHello(item)">忽略</span>
                <span class="ignore" v-if="item.toState == 1">已回复</span>
                <span class="read" @click="read(item)" v-else>回复</span>
              </div>
          </div>
          <!-- 展商身份 -->
          <div class="bottom-shop" v-if="item.matedata.From.UserRole && item.matedata.From.UserRole == 'Exhibitor'">
              <div class="shop" v-if="true" @click="goshop()">
                <span >参观主页</span>
              </div>
              <div class="shop" v-else >
                <span  style="color: #999">参观主页</span>
              </div>
              <div class="live"  v-if="true" @click="golive()">
                <span>观看直播</span>
              </div>
              <div class="live" v-else >
                <span style="color: #999" >观看直播</span>
              </div>
            </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
    <div style="text-align:center;font-size:12px;color:#ccc;margin-top: 50px" v-else>暂无内容！</div>
    
    <replay ref="replay" @resetInit="resetInit"></replay>

  </div>
</template>

<script>
import gql from 'graphql-tag'
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
import replay from "@components/replay-model.vue";      // 回复

export default {  
  name: "contact-me",
  data() {
    return {
      loading: false,   //联系我的加载状态
      finished: false,  //联系我的是否完成状态
      dataList: [], //供需列表
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      totalPages: 0,
      querySayHello:'',
    };
  },
  components: { List , replay },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
    MemberGql(){
        return gql `query
                querySayHello($query: QueryInput!){
                    querySayHello(query:$query){
                       hasNextPage
                       pageIndex
                       totalCount
                       items{
                        content
                        createAt
                        exhibitionId
                        exhibitorId
                        fromId
                        id
                        matedata
                        sayTypes
                        toClickCount
                        toId
                        typeIds
                        toContent
                        toState
                       }
                    }
                }`
      },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      addHelloRead:'my/addHelloRead',
      putSayHello2:'my/putSayHello2'
    }),
    init(){
      this.getList();
    },
    getList(){
      let where = {
          "Equal":{
            "n":"exhibitionId",
            "v":this.exhibitionId
          },
          "Equal2":{
            "n":"toId",
            "v":this.userInfo.inMember.id
          },
          "NotEqual":{
            "n":"toState",
            "v":2
          },
      };
      let order = [
        {
          "N":"toClickCount",
          "v":1
        },
        {
          "N":"createAt",
          "v":0
        }
      ];
      this.$apollo.addSmartQuery("querySayHello",{
        query:this.MemberGql,
        variables:{
          query:{
            page: this.pageIndex,
            size: this.pageSize,
            where:JSON.stringify(where),
            order:JSON.stringify(order),
          }
        },
        fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
        result(res){
          let data = JSON.parse(JSON.stringify(res));
         
          if(data&&data.data.querySayHello){
            let currentList = data.data.querySayHello.items;
            currentList.map(c=>{
              if(c.matedata){
                c.matedata = JSON.parse(c.matedata);
              }
            })
            if(this.pageIndex == 1){
              this.dataList = currentList;
            } else {
              this.dataList = [...this.dataList,...currentList]
            }
            this.loading = false;
            if (!data.data.querySayHello.hasNextPage) {
              this.finished = true;
            }
          }
        },
        error(error) {
          console.error(error,'error错误处理')
        }
      })
    },
    //
    loadMore(){
      if (this.finished) return;
      this.pageIndex += 1;
      // console.log(this.pageIndex,'当前加载的页面')
      this.getList();
    },
    async loseHello(e){
      let opt={
        id:e.id,
        req:{
          toState:2
        }
      }
      let res = await this.putSayHello2(opt);
      if(res.result){
        this.dataList=this.dataList.filter(item => item.id!=e.id);
      }else{
        this.$toast.fail('忽略失败')
      }
    },
    //设为已读
    async read(item){
      this.$refs.replay.open(item);
      let opt = {
        sayHelloId: item.id
      };
      let res =  await this.addHelloRead(opt);
    },
    resetInit(id){
      this.dataList.map(c=>{
        if(c.id == id) {
          c.toState = 1;
        }
      })
    },
    
  }
};
</script>

<style scoped lang="scss">
//展品列表
.contact_me{
  .list_wrap{
    .item{
        background-color: #fff;
        margin-bottom: 0.3rem;
        border-radius: 0.05rem;
        box-shadow: 0 0  0.1rem 0
        rgba(0, 0, 0, 0.1);
        border-radius: 0.05rem;
        padding:0.2rem;
      .item_top {
        color: #333;
        display: flex;
        .logo {
          position: relative;
          width: 0.88rem;
          height: 0.88rem;
          margin-right: 0.14rem;
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
        .details {
          .line {
            display: flex;
            align-items: flex-end;
            margin-bottom: 0.16rem;
            .name {
              font-size: 0.26rem;
              margin-right: 0.1rem;
              font-weight: 400;
            }
            .job {
              font-size: 0.22rem;
              color: #666;
            }
          }
          .info2 {
            font-size: 0.22rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .txt {
          width: 2rem;
          padding-top: 0.16rem;
          text-align: right;
          font-size: 0.2rem;
          color: #bfbfbf;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .create_time{
          margin-left: auto;
          flex-shrink: 0;
          font-size: 0.2rem;
          color: #bfbfbf;
        }
        &-gx{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &-b {
          display: flex;
          .cclb {
            &-l {
              font-size: 0.2rem;
              width: 80%;
              padding-top: 0.13rem;
              .txt2 {
                color: #ffcc00;
                width: calc(100% - 1px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .txt3 {
                width: calc(100% - 1px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            &-r {
              width: 20%;
              text-align: right;
              .btn {
                height: 0.48rem;
                line-height: 0.48rem;
                display: inline-block;
                padding: 0 0.2rem;
                background-color: #f85b0f;
                border-radius: 0.04rem;
              }
            }
          }
        }
      }
      .item_bottom{
        .bottom-btn{
          display: flex;
          justify-content: flex-end;
          .ignore{
            width: 1.42rem;
            height: 0.48rem;
            border-radius: 0.24rem;
            border: solid 1px #d9d9d9;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #666;
            background-color: #e6e6e6;
          }
          .read{
            width: 1.42rem;
            height:0.48rem;
            background-color: #f85b0f;
            border-radius: 0.24rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
          }
          .lose{
            width: 1.1rem;
            margin-right: 0.2rem;
             height: 0.48rem;
            text-align:center;
            border-radius: 0.24rem;
            border: solid 1px #d9d9d9;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #666;
          }
        }
        p{
          font-family: PingFang-SC-Regular;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0;
          font-size: 0.26rem;
          padding:0.2rem 0;
          color: #333;
        }
        ._van-button{
          .van-button{
            width: 110rpx;
            height: 48rpx;
            background-color: #f85b0f;
            border-radius: 24rpx;
          }
        }
      }
      .bottom-shop{
        transform: translateY(0.2rem);
        margin-top: 0.2rem;
        display: flex;
        align-items: center;
        height:0.82rem;
        width: calc(100% + 0.4rem);
        margin-left: -0.2rem;
        border-top: 1px solid #e5e5e5;
        .shop{
          text-align: center;
          width:50%;
          height:100%;
          border-right:1px solid #e5e5e5 ;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .live{
          text-align: center;
          width: 50%;
        }
        span{
          font-size: 0.26rem;
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
